define('views/content/recurring_licenses',['require','views/base/list_page_view','views/components/recurring_product/recurring_products','collections/recurring_products','collections/customer_recurring_products','text!templates/content/recurring_licenses.html'],function(require){

    var BaseListPageView = require('views/base/list_page_view');

    var RecurringProductsView = require('views/components/recurring_product/recurring_products');
    var RecurringProductsCollection = require('collections/recurring_products');
    var CustomerRecurringProductsCollection = require('collections/customer_recurring_products');



    var temp = require("text!templates/content/recurring_licenses.html");
    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'subscriptions-page',
        titleKey: 'subscriptions',

        setCollection: function () {
            if(App.user.get('customer')){
                this.collection = new CustomerRecurringProductsCollection();
            }else{
                this.collection = new RecurringProductsCollection();
            }
        },

        regions: function() {
            return {
                ListContainer: ".main-list-container",
            };
        },

        onRender: function() {
            this.ListContainer.show(new RecurringProductsView({
                collection: this.collection
            }));
        }

    });
});
